import React from 'react';

import { jpgPath } from '../../helpers/image-factory';
import Image from '../image';

export const SERVICE_SEGMENT_IMAGE_WIDTH = 846;
export const SERVICE_SEGMENT_IMAGE_HEIGHT = 554;

export const getServiceSegmentImage = (imageId: string, altText: string) => (
  <Image
    images={[
      {
        src: jpgPath(
          imageId,
          SERVICE_SEGMENT_IMAGE_WIDTH,
          SERVICE_SEGMENT_IMAGE_HEIGHT,
        ),
        width: SERVICE_SEGMENT_IMAGE_WIDTH,
        height: SERVICE_SEGMENT_IMAGE_HEIGHT,
        media: '',
      },
    ]}
    alt={altText}
  ></Image>
);
